module.exports = __webpack_public_path__ + "img/breakfast.62eabda5.jpeg";